import React from "react";
import fabricBg from "../../assets/login/fabric-bg.png";
import pageBgFull from "../../assets/login/page-bg-full.png";
import fashionShop from "../../assets/login/fashion-shop.png";

const panelBg = {
  backgroundImage: `linear-gradient(145deg, rgba(249,246,241,0.88) 0%, rgba(239,231,220,0.85) 100%), url(${fabricBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const SitaramWordmark = ({ size = "lg" }) => (
  <span className="flex flex-col items-center select-none">
    <span
      className={`font-bold uppercase leading-none text-[#0B1C30] ${
        size === "lg" ? "text-5xl tracking-[0.14em]" : "text-4xl tracking-[0.12em]"
      }`}
    >
      Sitaram
    </span>
    <span className="mt-3 flex items-center gap-3">
      <span className="h-px w-8 bg-[#C5B396]" />
      <span className="text-xs font-semibold uppercase tracking-[0.4em] text-[#7D766C]">
        Cloth
      </span>
      <span className="h-px w-8 bg-[#C5B396]" />
    </span>
  </span>
);

/**
 * Website login layout themed with Figma mobile app colors
 * (navy / taupe / gold / cream) — Sitaram brand.
 */
const LoginPageShell = ({ children, onBrandTap, onIllustrationTap, showLocalBadge = false }) => {
  return (
    <div className="relative min-h-screen">
      {showLocalBadge && (
        <div className="fixed top-3 left-1/2 z-50 -translate-x-1/2 pointer-events-none">
          <span className="inline-block rounded-full bg-[#7D766C] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-white shadow-md">
            local
          </span>
        </div>
      )}
      {/* Outer page only: Figma full BG image + soft opacity */}
      <div className="absolute inset-0 z-0 overflow-hidden" style={{ backgroundColor: "#F7F3EE" }}>
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${pageBgFull})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            opacity: 0.42,
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(160deg, rgba(247,243,238,0.35) 0%, rgba(247,243,238,0.15) 45%, rgba(239,231,220,0.4) 100%)",
          }}
        />
      </div>
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-[70rem] mx-auto">
          <div
            className="w-full flex flex-col lg:flex-row rounded-3xl overflow-hidden shadow-2xl border border-[#E8DFD4] min-h-[34rem]"
            style={panelBg}
          >
            <div className="lg:w-3/5 p-8 hidden lg:flex flex-col relative overflow-hidden min-h-[34rem] bg-transparent">
              <div className="relative z-10 flex flex-col flex-1 items-center justify-between w-full max-w-md mx-auto py-4">
                <div className="text-center w-full flex-1 flex flex-col items-center justify-center">
                  <button
                    type="button"
                    className="mx-auto mb-8 bg-transparent p-0 border-0 cursor-default"
                    onClick={onBrandTap}
                    aria-label="Sitaram"
                  >
                    <SitaramWordmark />
                  </button>
                  <button
                    type="button"
                    className="mb-6 bg-transparent p-0 border-0 cursor-default w-full max-w-[360px]"
                    onClick={onIllustrationTap}
                    aria-label="Shop illustration"
                  >
                    <img
                      src={fashionShop}
                      alt=""
                      aria-hidden
                      className="w-full h-auto object-contain select-none pointer-events-none"
                      draggable={false}
                    />
                  </button>
                  <h2 className="text-xl font-semibold mb-2 text-[#0B1C30]">
                    Trusted Clothing Manufacturer
                  </h2>
                  <p className="text-sm max-w-sm text-[#4C463D]">
                    Manufacturing quality clothing with precision — from fabric
                    cutting to final finishing, every piece is made with care.
                  </p>
                </div>

              </div>
            </div>

            <div className="lg:w-2/5 p-8 sm:p-10 bg-transparent">
              <div className="w-full max-w-md mx-auto h-full flex flex-col items-center justify-center gap-6">
                <div className="lg:hidden mb-2 flex flex-col items-center gap-3">
                  <div onClick={onBrandTap} role="presentation">
                    <SitaramWordmark size="sm" />
                  </div>
                  <button
                    type="button"
                    className="bg-transparent p-0 border-0 cursor-default w-full max-w-[200px]"
                    onClick={onIllustrationTap}
                    aria-label="Shop illustration"
                  >
                    <img
                      src={fashionShop}
                      alt=""
                      aria-hidden
                      className="w-full h-auto object-contain select-none pointer-events-none"
                      draggable={false}
                    />
                  </button>
                </div>
                <div
                  className="rounded-3xl p-8 max-w-md w-full border border-[#E8DFD4]/90"
                  style={{
                    backgroundColor: "rgba(249, 246, 241, 0.97)",
                    boxShadow:
                      "0 20px 40px -12px rgba(75, 68, 58, 0.18), 0 8px 16px -8px rgba(75, 68, 58, 0.12)",
                  }}
                >
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const loginLinkClass =
  "text-sm font-bold text-[#7D766C] hover:text-[#5C564E] transition-colors";

export const loginPrimaryBtnClass =
  "w-full !bg-[#7D766C] hover:!bg-[#6A645C] !text-white !shadow-[0_10px_15px_-3px_rgba(197,179,150,0.25)] !rounded-xl !py-3 !px-4 focus:!ring-[#C5B396]";

export const loginTitleClass = "text-2xl font-bold mb-2 text-[#0B1C30]";
export const loginMutedClass = "text-sm text-[#4C463D]";

export default LoginPageShell;
